var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpeneye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.25C8.25 6.25 21.75 6.25 26.25 16.25",
    stroke: "#A0A0A0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.25C14.5075 21.25 14.0199 21.153 13.5649 20.9645C13.11 20.7761 12.6966 20.4999 12.3483 20.1517C12.0001 19.8034 11.7239 19.39 11.5355 18.9351C11.347 18.4801 11.25 17.9925 11.25 17.5C11.25 17.0075 11.347 16.5199 11.5355 16.0649C11.7239 15.61 12.0001 15.1966 12.3483 14.8483C12.6966 14.5001 13.11 14.2239 13.5649 14.0355C14.0199 13.847 14.5075 13.75 15 13.75C15.9946 13.75 16.9484 14.1451 17.6517 14.8483C18.3549 15.5516 18.75 16.5054 18.75 17.5C18.75 18.4946 18.3549 19.4484 17.6517 20.1517C16.9484 20.8549 15.9946 21.25 15 21.25Z",
    stroke: "#A0A0A0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeneye);
export default __webpack_public_path__ + "static/media/openeye.c2d8fcf7e2e10e1013f626e7daf30f61.svg";
export { ForwardRef as ReactComponent };